import $ from 'jquery';

// show and hide notification element on investment agreement form based on user selected values
$(document).on("turbo:load", function () {
  function handleSelectChange(selectElement) {
    var selectedValue = $(selectElement).val();
    var restrictedValues = $(selectElement).data("js-restricted-values");
    var allowedValues = $(selectElement).data("js-allowed-values");
    var targetSelector = $(selectElement).data("js-when-value-chosen-show");
    var parentFormSection = $(selectElement).closest("[data-role='form-section-inputs']");
    var targetElement = parentFormSection.find(targetSelector); // check to find correct target element inside same form section when page has multiple elements

    if (selectedValue && (restrictedValues || allowedValues)) {
      if (restrictedValues && restrictedValues.includes(selectedValue)) {
        showNotification(targetElement);
      } else if (allowedValues && !allowedValues.includes(selectedValue)) {
        showNotification(targetElement);
      } else {
        // Check if any other element with the same data-js-when-value-chosen-show attribute has the value
        var anyOtherMatching = false;
        parentFormSection
          .find('[data-js-when-value-chosen-show="' + targetSelector + '"]')
          .each(function (index, el) {
            if (
              restrictedValues && restrictedValues.includes($(el).val()) ||
              allowedValues && !allowedValues.includes($(el).val())
            ) {
              anyOtherMatching = true;
            }
          });

        // Hide element if no other matched found
        if (!anyOtherMatching) {
          hideNotification(targetElement);
        }
      }
    } else {
      hideNotification(targetElement);
    }
  }

  function showNotification(targetElement) {
    $(targetElement).show().removeClass("hidden");
  }

  function hideNotification(targetElement) {
    $(targetElement).hide();
  }

  // Call the function on page load for each select element with the data attributes
  $("[data-js-when-value-chosen-show]").each(function () {
    handleSelectChange(this);
  });

  // Add event listener for change event on each select element with the data attributes
  $("[data-js-when-value-chosen-show]").change(function () {
    handleSelectChange(this);
  });
});
